import { postRequest, patchRequest, deleteRequest } from "@react/helpers/fetch"

export const createAcceptance = (projectId, body) =>
  postRequest({ url: `/projects/${projectId}/acceptance.json`, body: { acceptance: body } })

export const updateAcceptance = (projectId, body) =>
  patchRequest({ url: `/projects/${projectId}/acceptance.json`, body: { acceptance: body } })

export const destroyAcceptance = (projectId) =>
  deleteRequest(`/projects/${projectId}/acceptance.json`)

export const finalizeAcceptance = (projectId) =>
  patchRequest({ url: `/projects/${projectId}/acceptance/finalize.json`, body: {} })
